export default __webpack_public_path__ + "static/media/625.0d458c94.png";